import React from 'react'


import QuickAdd_Group from "../../../../common/group";
import QuickAdd_BreadcrumbNavigation from "../../../../layout/page-title/form-title-breadcrumb";
import VScroll from '../../../../../../core/gd-components/scrolling/custom-v-scroll/v-scroll';
import {BreadcrumbElement} from "../../../../../../core/gd-components/breadcrumbs/breadcrumbs-custom";
import {QuickAddBreadcrumbElement} from "../../../../@types";
import QuickAdd_NewDashboard_TypeItem from "./type-item";
import {NewDashboard_SelectedType} from "../../new-dasshboard-main";


export type DashboardsTypeOption = {
    typeId      : NewDashboard_SelectedType
    title       : string,
    description : string
    preview     : string,
    comingSoon? : boolean
}

type Props = {
    onSelectDashboardType    : {(type: any): void}
}

// const debug = "QuickAdd_NewDashboard_SelectType"
const debug = false


export default function QuickAdd_NewDashboard_SelectType(props: Props) {

    const breadcrumbs: BreadcrumbElement[] = [QuickAddBreadcrumbElement.DASHBOARD]

    const customDashboardsTypeOption = {
        typeId      : 'custom',
        title       : 'Custom Dashboard',
        description : 'A flexible dashboard created from scratch where you can combine widgets and data from across the workspace.',
        preview     : "custom-templates.svg"
    } as DashboardsTypeOption

    const projectDashboardsTypeOption = {
        typeId      : 'project',
        title       : 'Project Dashboard',
        description : 'Displays widgets and metrics related to a project, helping you track progress, tasks, timelines, and overall project status.',
        preview     : "project-templates.svg"
    } as DashboardsTypeOption

    const userDashboardTypeOption = {
        typeId      : 'user',
        title       : 'User Dashboard',
        description : 'Displays widgets and metrics related to a specific user, helping you review their assignments, activity, workload, and performance.',
        comingSoon  : true,
        preview     : "user-templates.svg"
    } as DashboardsTypeOption

    return (
        <div className="new-main dashboard">

            <QuickAdd_BreadcrumbNavigation breadcrumbItems={breadcrumbs}/>

            <VScroll
                className="quick-add-content p-t-50 p-l-50"
                style = {{
                    width: '90%'
                }}
            >
                {/*<QuickAdd_Group className="m-b-20">*/}
                <QuickAdd_NewDashboard_TypeItem
                    dashboardTypeConfig = {customDashboardsTypeOption}
                    onSelect            = {props.onSelectDashboardType}
                />

                <div className="line-through m-b-30 m-t-30 m-r-40"/>

                <QuickAdd_NewDashboard_TypeItem
                    dashboardTypeConfig = {projectDashboardsTypeOption}
                    onSelect            = {props.onSelectDashboardType}
                />

                <div className="line-through m-b-30 m-t-30 m-r-40"/>

                <QuickAdd_NewDashboard_TypeItem
                    dashboardTypeConfig = {userDashboardTypeOption}
                    onSelect            = {props.onSelectDashboardType}
                />
                    {/*</QuickAdd_Group >*/}
            </VScroll>
        </div>
    )
}
